import { render, staticRenderFns } from "./EBITVorlaeufigesErgebnis.vue?vue&type=template&id=5f04af50&"
import script from "./EBITVorlaeufigesErgebnis.vue?vue&type=script&lang=ts&"
export * from "./EBITVorlaeufigesErgebnis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports